export const DIAGNOSTICS_CONSTANTS = {
  CLIENT_SAFE_CHAR_LIMIT: 12000,
  OPEN_SYNC_LOGS: {
    MAX_INSPECTIONS: 20,
    MAX_BYTES_PER_INSPECTION: 256 * 1024,
    MAX_AGE_MS: 24 * 60 * 60 * 1000,
    MAX_EVENTS: 200,
    PERSIST_DEBOUNCE_MS: 500,
  },
  PENDING_LOGS: {
    MAX_PARTS: 500,
    MAX_BYTES: 5 * 1024 * 1024,
    MAX_AGE_MS: 7 * 24 * 60 * 60 * 1000,
    MAX_ATTEMPTS: 10,
    LEASE_MS: 30 * 1000,
    BASE_RETRY_MS: 1000,
    MAX_RETRY_MS: 5 * 60 * 1000,
  },
  STRING_TRUNCATE: 2000,
} as const;

export type SyncLogOutcome = 'success' | 'failed' | 'interrupted';

export type SyncLogLevel = 'debug' | 'info' | 'warning' | 'error';
